import { Product } from "../../classes/product";
import { SimpleProduct } from "../../classes/simple_product";
import { OrderDetail } from "../../classes/order_detail";
import { OrderAmounts } from "../../classes/order_amounts";
import { PromoOrderAmounts } from "../../classes/promo_order_amounts";
import { Promotion } from "../../classes/promotion";
import { PromotionDetail } from "../../classes/promotion_detail";
import { SimplePromotion } from "../../classes/simple_promotion";

export default {
   methods: {
      /**
       * Genera el order detail
       * @param {[Product, SimpleProduct]} product 
       * @param {*} pieces 
       * @returns {OrderDetail}
       */
      setOrderDetail(product, pieces){
         let sub = parseFloat(product.price) * pieces
         let iva = parseFloat(product.iva) * pieces
         let ieps = parseFloat(product.ieps) * pieces
         let cost = parseFloat(product.cost) * pieces
         let boxes = pieces / product.box_pieces
         return new OrderDetail(product.id, product, pieces, boxes, sub, iva, ieps, cost, 0, 0)
      },

      /**
       * Genera el order detail
       * @param {SimpleProduct} product 
       * @param {*} pieces 
       * @returns {OrderDetail}
       */
      setGiftOrderDetail(product, pieces){
         let boxes = pieces / product.box_pieces
         let discount = parseFloat(product.cost) * pieces
         return new OrderDetail(product.id, product, pieces, boxes, 0, 0, 0, 0, discount, 0, true)
      },

      /**
       * 
       * @param {Promotion} promotion 
       * @param {*} quantity 
       * @param {OrderDetail[]} order_details
       * @param {*} total 
       */
      setPromotionDetail(promotion, quantity, order_details, total, discount, totalDiscounted){
         let simple_promo = SimplePromotion.fromPromotion(promotion)
         return new PromotionDetail(simple_promo, quantity, order_details, total, discount, totalDiscounted)
      },

      /**
       * 
       * @param {Array} order_details
       * @returns {OrderAmounts}
       */
      calculateTotalAmounts(order_details){
         let sub = 0
         let iva = 0
         let ieps = 0
         let discount = 0
         let after_tax_total = 0
         order_details.forEach(det => {
            sub += det.subtotal
            iva += det.iva
            ieps += det.ieps
            discount += det.discount
            after_tax_total += det.cost
         });

         const final_total = after_tax_total - discount
         const tax = ieps + iva
         return new OrderAmounts(sub, ieps, iva, tax, after_tax_total, discount, final_total)
      },

      /**
       * 
       * @param {*} promo_details 
       * @returns {PromoOrderAmounts}
       */
      calculateTotalPromoAmounts(promo_details) {
         let sub = 0
         let subtotal_order_lines = 0
         let iva = 0
         let ieps = 0
         let discount = 0
         let after_tax_total = 0
         promo_details.forEach(prom => {
            prom.order_details.forEach(det => {
               subtotal_order_lines += det.subtotal
            });
            sub += prom.total
            iva += 0
            ieps += 0
            discount += prom.discount
            after_tax_total += prom.total
         });

         const final_total = after_tax_total - discount
         const tax = ieps + iva
         return new PromoOrderAmounts(sub, subtotal_order_lines, ieps, iva, tax, after_tax_total, discount, final_total)
      }
   }
}